import styles from "./styles.module.scss";

function PageContainer(props: any) {
  const {
    className = "", children, showGreyContainer = false,
    ShowGreyOuterContainer = false, classNameOuter = "", style,
    fullWidth = false,
    isApparelLayout = false,
  } = props;
  return (
    <div
      id="page-container"
      className={`${classNameOuter} ${styles.root_container}
      ${ShowGreyOuterContainer ? styles.greyContainer : styles.whiteContainer}`}
    >

      <div
        className={`${className} ${showGreyContainer ? styles.greyContainer : styles.whiteContainer}
      ${fullWidth ? styles.full_width : ""} ${isApparelLayout ? styles.isApparelLayout_width : ""}`}
        style={style}
      >
        {children}
      </div>
    </div>
  );
}

export default PageContainer;
